export const PP_ACCEPTED = 'PP_ACCEPTED';
